<template>
    <b-row class="cantidad-suman" align-h="start">
        <b-col cols="12" lg="12">
            <b-row align-h="center" class=" justify-content-lg-center cantidad-suman-content-block"  >
                <br>
                <b-col v-for="(item, index) in content" :key="index" class="col-center cantidad-suman-block"  lg="2" md="4"  cols="12">
                    <p class="mt-4 cantidad-suman-total" v-html="item.total">  </p>
                    <p class="mt-4 cantidad-suman-titulo " v-html="item.titulo">  </p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>

    export default {
        name: 'section-cant-suman',
        components: {
        },
        props: {
            content: Array
        },
        data: () => ({

        }),
        computed: {
            srcImagen() {
                let src = require('@/assets/images/commerce_internal/' + this.content.imagen)
                return src
            }
        }
    }
</script>
<style scoped>
</style>